import React, { useEffect, useRef } from 'react';

//  This provides best-effort deterrents (no absolute protection found yet on the web).
const ProtectedContent = ({ children }) => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    const prevent = (e) => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    const handleKeyDown = (e) => {
      const isMac = /Mac|iPod|iPhone|iPad/.test(navigator.platform);
      const ctrlOrCmd = isMac ? e.metaKey : e.ctrlKey;
      const key = (e.key || '').toLowerCase();
      // Block common shortcuts: copy, save, print
      if (ctrlOrCmd && (key === 'c' || key === 's' || key === 'p')) {
        return prevent(e);
      }
      // Best-effort for PrintScreen (cannot reliably block OS screenshots)
      if (e.key === 'PrintScreen') {
        try { navigator?.clipboard?.writeText?.(''); } catch (_) {}
        return prevent(e);
      }
    };

    const el = wrapperRef.current;
    if (el) {
      el.addEventListener('copy', prevent);
      el.addEventListener('contextmenu', prevent);
      el.addEventListener('dragstart', prevent);
      el.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      if (el) {
        el.removeEventListener('copy', prevent);
        el.removeEventListener('contextmenu', prevent);
        el.removeEventListener('dragstart', prevent);
        el.removeEventListener('keydown', handleKeyDown);
      }
    };
  }, []);

  return (
    <div
      ref={wrapperRef}
      // Disable text selection for contained DOM (iframes are not affected)
      style={{
        userSelect: 'none',
        WebkitUserSelect: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none',
      }}
      // Make div focusable to receive keydown events
      tabIndex={0}
    >
      {children}
    </div>
  );
};

export default ProtectedContent;
